export class Flag {
   constructor({
      id = null,
      companyId = null,
      studyId = null,
      period = null,
      createdAt = null,
      ruleName = null,
      failureInstructions = false,
      severityLevel = null,
      verified = null,
      verifiedBy = null,
      verifiedByUserId = null,
      userId = null,
      status = null,
      relatedRowId = null,
      relatedTableName = null,
   } = {}) {
      this.id = id;
      this.companyId = companyId;
      this.studyId = studyId;
      this.period = period;
      this.createdAt = createdAt;
      this.ruleName = ruleName;
      this.failureInstructions = failureInstructions;
      this.severityLevel = severityLevel;
      this.verified = verified;
      this.verifiedBy = verifiedBy;
      this.verifiedByUserId = verifiedByUserId;
      this.userId = userId;
      this.status = status;
      this.relatedRowId = relatedRowId;
      this.relatedTableName = relatedTableName;
   }

   copy() {
      return new Flag({
         id: this.id,
         companyId: this.companyId,
         studyId: this.studyId,
         period: this.period,
         createdAt: this.createdAt,
         ruleName: this.ruleName,
         failureInstructions: this.failureInstructions,
         severityLevel: this.severityLevel,
         verified: this.verified,
         verifiedBy: this.verifiedBy,
         verifiedByUserId: this.verifiedByUserId,
         userId: this.userId,
         status: this.status,
         relatedRowId: this.relatedRowId,
         relatedTableName: this.relatedTableName,
      });
   }

   export() {
      return {
         id: this.id,
         companyId: this.companyId,
         studyId: this.studyId,
         period: this.period,
         createdAt: this.createdAt,
         ruleName: this.ruleName,
         failureInstructions: this.failureInstructions,
         severityLevel: this.severityLevel,
         verified: this.verified,
         verifiedBy: this.verifiedBy,
         verifiedByUserId: this.verifiedByUserId,
         userId: this.userId,
         status: this.status,
         relatedRowId: this.relatedRowId,
         relatedTableName: this.relatedTableName,
      };
   }
}
